import React from 'react';
import { FaSpinner } from 'react-icons/fa';

export const Loading = (): React.ReactElement => (
  <FaSpinner className="spinner stroke-current mx-auto" />
);
